import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  founderImg: {
    borderRadius: '50%',
    width: '170px',
    height: '170px',
    overflow: 'hidden',
    margin: 'auto',
    marginBottom: theme.spacing(2),
  },
}));
export default style;
